const classes = Object.freeze({
    root: 'll-input',
});

export {
    classes,
};